<template>
  <div class="l-container ContractsIndex">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'name'">名前</template>
      <template v-if="this.sortColumn === 'kana'">かな</template>
      <template v-if="this.sortColumn === 'address'">住所</template>
      <template v-if="this.sortColumn === 'office_id'">営業所</template>
      <template v-if="this.sortColumn === 'contract_type'">契約種類</template>
      <template v-if="this.sortColumn === 'contract_date'">契約日</template>
      <template v-if="this.sortColumn === 'cancel_type'">解約種類</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
      <template v-if="this.sortColumn === 'updated_at'">更新日</template>
       : {{sortState}}
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_type')" v-bind:class="{ 'active': contract_type }">契約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_date')" v-bind:class="{ 'active': contract_date }">契約日</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_date_end')" v-bind:class="{ 'active': contract_date_end }">〜契約日</btn>
        <btn class="m-btn--column" @click.native="switchV('cancel_type')" v-bind:class="{ 'active': cancel_type }">解約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">更新日</btn>
      </div>
    </template>

    <div class="index-box" @scroll="offset">
      <table-c>
        <tr-c slot="tr-th">
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="kana"><td-c><input v-model="search.kana" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="address"><td-c><input v-model="search.address" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="office_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_type"><td-c><input v-model="search.contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="contract_date"><td-c><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="contract_date_end"><td-c><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="cancel_type"><td-c><input v-model="search.cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="kana"><td-c><input v-model="search.not_kana" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="address"><td-c><input v-model="search.not_address" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="office_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contract_type"><td-c><input v-model="search.not_contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="contract_date_end"><td-c><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="cancel_type"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="updated_at"><td-c><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>名前</th-c></template>
          <template v-if="kana"><th-c @click.native='sort("kana")'>かな</th-c></template>
          <template v-if="address"><th-c @click.native='sort("address")'>住所</th-c></template>
          <template v-if="office_id"><th-c @click.native='sort("office_id")'>営業所</th-c></template>
          <template v-if="contract_type"><th-c @click.native='sort("contract_type")'>契約種類</th-c></template>
          <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>契約日</th-c></template>
          <template v-if="contract_date_end"><th-c @click.native='sort("contract_date_end")'>〜契約日</th-c></template>
          <template v-if="cancel_type"><th-c @click.native='sort("cancel_type")'>解約種類</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
          <template v-if="updated_at"><th-c @click.native='sort("updated_at")'>更新日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in mapContracts" :key="index.id" class="tr_hover">
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="name"><td-c>{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="kana"><td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="address"><td-c>{{list.address}} {{list.address2}}</td-c></template>
          <template v-if="office_id"><td-c>{{list.mapOfficeId}}</td-c></template>
          <template v-if="contract_type"><td-c>{{list.contract_type}}</td-c></template>
          <template v-if="contract_date"><td-c>{{list.contract_date}}</td-c></template>
          <template v-if="contract_date_end"><td-c></td-c></template>
          <template v-if="cancel_type"><td-c>{{list.cancel_type}}</td-c></template>
          <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/contracts/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'contract',
  pageNames: 'contracts'
}

let _ = window._
export default {
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: true,
      name: true,
      kana: true,
      address: true,
      office_id: true,
      contract_type: true,
      contract_date: true,
      contract_date_end: true,
      cancel_type: true,
      created_at: false,
      updated_at: false,

      search: {
        id: '',
        name: '',
        kana: '',
        address: '',
        office_id: '',
        contract_type: '',
        contract_date: [],
        cancel_type: '',
        created_at: '',
        updated_at: '',

        not_id: '',
        not_name: '',
        not_kana: '',
        not_address: '',
        not_office_id: '',
        not_contract_type: '',
        not_contract_date: [],
        not_cancel_type: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
        office_id: '',
        not_office_id: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    offices () {
      return this.$store.getters.offices
    },

    contracts () {
      return this.$store.getters.contracts
    },

    orderedContracts () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.contracts, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.contracts, this.sortColumn)
      }
    },

    mapContracts () {
      return this.orderedContracts.map(contract => {
        contract.mapOfficeId = this.calcArry(contract.office_id, 'offices')
        return contract
      })
    }
  },
  watch: {
    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      }
    }
  },
  methods: {
    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return val === item.id
        })[0].name
      } else {
        return
      }
    },

    switchV (col) {
      this[col] = !this[col]
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    reset () {
      this.id = false
      this.name = false
      this.kana = false
      this.address = false
      this.office_id = false
      this.contract_type = false
      this.contract_date = false
      this.cancel_type = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.id = true
      this.name = true
      this.kana = true
      this.address = true
      this.office_id = true
      this.contract_type = true
      this.contract_date = true
      this.cancel_type = true
      this.created_at = true
      this.updated_at = true
    },

    linkContract (contract) {
      this.$router.push({name: 'contract', params: { id: contract.id }})
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 150px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.ContractsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// ContractsIndex.vue?07f869d0